import { isLateEntry } from '@/lib/lateEntry';

/** Small "Late" marker for a back-filled row: entered on a later day than it is for. */
export function LateChip({ row, entryDate }: { row: Parameters<typeof isLateEntry>[0]; entryDate: string }) {
  if (!isLateEntry(row, entryDate)) return null;
  return (
    <span
      className="shrink-0 rounded-full bg-sky-50 px-2 py-0.5 text-xs font-semibold text-sky-800"
      title="Entered on a later day than it is for"
      data-late-chip
    >
      Late
    </span>
  );
}
